import Cubit from "../../core/utils/cubit";

type ProcessingState = 'PROCESSING' | 'PROCESSED';

abstract class IProcessingService extends Cubit<ProcessingState> {
    abstract startProcessing: () => void;
    abstract stopProcessing: () => void;
}

class ProcessingService extends IProcessingService {
    private static instance: IProcessingService;
    private constructor() {
        super('PROCESSED');
    }
    public static getInstance(): IProcessingService {
        if (this.instance === undefined) {
            this.instance = new ProcessingService();
        }
        return this.instance;
    }

    startProcessing: () => void = () => {
        if (this.state !== "PROCESSING") {
            this.emit("PROCESSING");
        }
    };

    stopProcessing: () => void = () => {
        if (this.state !== "PROCESSED") {
            this.emit("PROCESSED");
        }
    };
}

export { IProcessingService, ProcessingService, ProcessingState };
